import memoizeOne from 'memoize-one';
var defaultTimeColumns = [24, 60, 60].map(function (length) { return Array(length).fill(0).map(function (v, index) { return ({ value: String(index) }); }); });
export var MAX_HOUR = 23;
export var MAX_MINUTE = 59;
export var MAX_SECOND = 59;
function createTimeColumnsImpl(hourStep, minuteStep, secondStep, containSecond) {
    var steps = [hourStep, minuteStep, secondStep];
    var result = defaultTimeColumns.map(function (col, i) { return col.filter(function (cell) { return Number(cell.value) % steps[i] === 0; }); });
    if (!containSecond) {
        result.pop();
    }
    return result;
}
export var createTimeColumns = memoizeOne(createTimeColumnsImpl);
